import { risapi, getAxiosConfig, getAPIFullUrl, printPDF } from './risapi';

/**
 * Fetches the authenticated user's wallet details (balance and transactions).
 * @param {object} filters - Pagination and search filters.
 * @param {function} callback - The function to call with the response.
 */
export const getMyWalletDetails = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/my-wallet', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Fetches the detailed transaction ledger for a specific date range.
 * THIS IS THE NEW FUNCTION.
 * @param {object} dateRange - An object with from_date and to_date.
 * @param {function} callback - The function to call with the response.
 */
export const getLedgerDetails = async (dateRange, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/my-wallet/ledger', dateRange), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Requests the backend to generate and download a PDF of the wallet ledger.
 * THIS IS THE NEW FUNCTION.
 * @param {object} dateRange - An object with from_date and to_date.
 * @param {function} callback - The function to call with the response.
 */
export const printLedgerPdf = async (dateRange, callback) => {
    // This function reuses your existing printPDF helper from risapi.js
    printPDF('/api/my-wallet/ledger/print', dateRange, callback);
};

